import {AbstractStandardPanel} from "@/scenes.ui/abstract-standard-panel";
import {Keys} from "@/constants/key";
import {VerticalLongPanel} from "@/scenes.ui/vertical-long-panel";
import SpriteUtils from "@/utils/sprite-utils";

export class WingedLongPanel extends VerticalLongPanel {

    protected addDecoration(): void {
        let wing1 = SpriteUtils.addImage(this.scene, -this.getXButtonX()-20, this.getXButtonY()-25, Keys.WHEEL_WING).setOrigin(0, 0);
        let wing2 = SpriteUtils.addImage(this.scene, this.getXButtonX()+20, this.getXButtonY()-25, Keys.WHEEL_WING, undefined, -1,1).setOrigin(0, 0);
        this.add(wing1);
        this.add(wing2);
    }
}
